import { CSSProperties } from 'react';

export const blockContainer: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 14px',
  backgroundColor: '#FFFFFF',
  borderRadius: '14px',
  cursor: 'pointer',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)',
  border: '1px solid rgba(0, 0, 0, 0.03)'
};

export const personalBlockContainer: CSSProperties = {
  backgroundColor: '#FFFFFF',
  borderRadius: '14px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)',
  border: '1px solid rgba(0, 0, 0, 0.03)',
  overflow: 'hidden'
};

export const menuItemStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  padding: '12px 14px',
  cursor: 'pointer',
  borderBottom: '1px solid rgba(0, 0, 0, 0.04)'
};

export const iconWrapperStyle: CSSProperties = {
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  background: 'linear-gradient(135deg, #F5F5F5 0%, #EBEBEB 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  marginRight: '12px',
  boxShadow: 'inset 0 1px 2px rgba(255, 255, 255, 0.8)'
};

export const afterStyle: CSSProperties = {
  fontSize: '13px',
  color: '#6B6B6E',
  marginTop: '3px',
  fontWeight: '400'
};

export const menuTextStyle: CSSProperties = {
  fontSize: '15px',
  fontWeight: '400',
  color: '#1A1A1A'
};
